import React from 'react';
import DoctorSchedule from './DoctorSchedule'; // Adjust the path based on your folder structure

const DoctorScheduleModal = ({ onClose }) => (
  <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Create Doctor Schedule</h5>
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <div className="modal-body">
          <DoctorSchedule />
        </div>
      </div>
    </div>
  </div>
);

export default DoctorScheduleModal;
